import React from 'react';
import {NeuroMessage, useGuideConfig, useNeuroMessages} from "@ignitesales/neuro-application";
import classnames from "classnames";

const Product = ({ isSelected, product, productActionCompleted, existingProducts, onApplyClick, showApplyButton}) => {
  const guideContext = useGuideConfig();
  const runMode = guideContext.runMode;
  const { getMessage } = useNeuroMessages();
  const cssBEM = 'product';
  const classes = classnames( cssBEM, {
    [`${cssBEM}--selected`]: isSelected
  });
  const learnMoreUrl = getMessage(`${product.id}.url`);
  const applyUrl = getMessage(`${product.id}.ctaUrl`);
  const learnMoreClicked = () => productActionCompleted('productDetailsLearnMoreClicked');

  const renderExistingProductMessage = () => {
    return existingProducts.length && existingProducts.includes(product.id.toString()) ?
    <div className={`${cssBEM}__existingProduct`}>
      <NeuroMessage id='summary.existingProduct' />
    </div>
    : null;
  };

  const renderProductFeatures = () => {
    const numberOfFeatures = parseInt(getMessage(`${product.id}.features.count`) || "0");
    const maxFeatures = 7;
    const count = numberOfFeatures > maxFeatures ? maxFeatures : numberOfFeatures;
    const features =  Array(count).fill(1).map( (v, index) => {
      const msgIndex = index + 1;
      const id = `${product.id}.features.${msgIndex}`;
      return <NeuroMessage shouldHideIfNotFound={true} id={id} tagName="li"/>
    });
    return features.length ?
      <div className={`${cssBEM}__features`}>
        <NeuroMessage id={'summary.features'} tagName='h5'/>
        <ul>{features}</ul>
      </div>
    : null
  };

  const renderProductActions = () => {
    return <div className={`${cssBEM}__action`}>
      {(showApplyButton) ? (
        <button className="btn btn-primary" onClick={() => onApplyClick(applyUrl)}>
          <NeuroMessage id='summary.applyNow'/>
        </button>
      ) : null}
    </div>
  };

  return (
    <div className={classes} key={product.id} data-product-id={product.id}>
      <div className={`${cssBEM}__container`}>
        <div className={`${cssBEM}__header`}>
          <h2>
            <NeuroMessage id={`${product.id}.name`} />
          </h2>
        </div>

        <div className={`${cssBEM}__details`}>
          <div className={`${cssBEM}__description`}>
            {!guideContext.isBranchGuide ? renderProductActions() : renderExistingProductMessage()}
            <span>
                <NeuroMessage id={`${product.id}.description.abbreviated`} />
              {learnMoreUrl ? (
                <>
                  <br />
                  <br />
                  <a href={learnMoreUrl} onClick={learnMoreClicked} target="_blank" aria-label={`Learn more about ${product.name}`} className="learnMoreLink">
                    <NeuroMessage id="product.learnMore" />
                  </a>
                  &nbsp;
                  <NeuroMessage id="product.learnMoreExpanded" />
                </>
              ) : null}
              </span>
          </div>
          {renderProductFeatures()}
        </div>


      </div>
    </div>
  );
};

export default Product;
